// cfgreftables

const getters = {
	getCfgRefTables(state) {
		return state.cfgreftables;
	},

};

export default getters;